export function checkActionType(type: string, expectedType: string): void {
  if (type !== expectedType) {
    throw new Error(expectedType.concat('-Saga was called with wrong Actiontype: ').concat(type));
  }
}
